// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@conklin/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

headerStyles.orderInfoGridItem = {
    css: css`
        display: flex;
        column-gap: 22px;
        margin-bottom: 16px;

        > div {
            flex: 0 1 317px;
        }
    `,
};

headerStyles.emailSentText = {
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 16px;
    `,
};

headerStyles.buttonsGridItem = {
    css: css`
        display: flex;
        column-gap: 24px;
        row-gap: 12px;
        flex-wrap: wrap;
    `,
};

headerStyles.createAccountBox = {
    container: {
        css: css`
            margin-top: 24px;
            display: flex;
            column-gap: 56px;
            justify-content: space-between;
            align-items: center;

            ${xScreen("lte", "md")} {
                flex-direction: column;
                row-gap: 12px;
                align-items: flex-start;
            }
        `,
    },
};

headerStyles.createAccountTitle = {
    variant: "h4",
    css: css`
        margin-bottom: 8px;
    `,
};

headerStyles.createAccountMessage = {
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 0;
    `,
};
